export default {
  props: {
    ignoreEmpty: {
      type: Boolean,
      default: true
    },

    toLowerCase: {
      type: Boolean,
      default: false
    },

    toUpperCase: {
      type: Boolean,
      default: false
    },

    trim: {
      type: Boolean,
      default: true
    },

    multiline: {
      type: Boolean,
      default: false
    },

    value: {
      type: String,
      default: undefined
    },
  },

  methods: {
    fromValue(value) {
      if (value === undefined || value === null) {
        return value;
      }

      if (this.trim) {
        // console.log('trim');
        value = value.trim();
      }

      if (this.toLowerCase) {
        // console.log('toLowerCase');
        value = value.toLowerCase();
      }

      if (this.toUpperCase) {
        // console.log('toUpperCase');
        value = value.toUpperCase();
      }

      if (this.ignoreEmpty && value === '') {
        // console.log('ignoreEmpty');
        value = undefined;
      }

      // console.log('Returning', value);
      return value;
    }
  }
}
